import { render, staticRenderFns } from "./RecentActivityWidget.vue?vue&type=template&id=35809313&scoped=true&"
import script from "./RecentActivityWidget.vue?vue&type=script&lang=js&"
export * from "./RecentActivityWidget.vue?vue&type=script&lang=js&"
import style0 from "./RecentActivityWidget.vue?vue&type=style&index=0&id=35809313&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35809313",
  null
  
)

export default component.exports